<template>
  <div class="moe_empty">
    <el-image class="moe_empty_bg_img" :src="imgPath(url)"></el-image>
    <div class="empty_text">{{emptyText}}</div>
  </div>
</template>

<script>
export default {
  name: "GjkcH5MoeEmpty",
  props:{
    url:{},
    emptyText:{}
  },

  data() {
    return {};
  },

  mounted() {},

  methods: {},
};
</script>

<style lang="scss" scoped>
.moe_empty {
  text-align: center;
  .moe_empty_bg_img {
    width: 260px;
    height: 260px;
  }
  .empty_text {
      color: #666;
      margin-top: -60px;
    }
}
</style>
